module.exports = __webpack_public_path__ + "img/shenqing.537709b5.jpg";